import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  const { t } = useTranslation();
  const featured = articles.slice(0, 3);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-bold text-foreground-900">
            <i className="ri-article-line mr-2 text-primary-500"></i>
            {t('articleList')}
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group cursor-pointer bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-[11px] font-medium rounded-full">
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-[11px] text-foreground-400">
                  <span>{article.publishDate}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {(article.readCount / 10000).toFixed(1)}万{t('readCount')}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}